import { Row } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import styles from "./style.module.css";

export function ThreadFile({
  label,
  url,
  endContent,
}: {
  label: string;
  url: string;
  endContent?: React.ReactNode;
}) {
  return (
    <a className={styles.threadFile} href={url} target="_blank" rel="noopener noreferrer">
      <Row alignItems="center" gapSize="xs">
        <Row.Item shrink>
          <span className="narmi-icon-file-text1" />
        </Row.Item>
        <Row.Item>
          <p className={styles.fileLabel} title={label}>
            {Filters.capitalizeFirstLetter(label)}
          </p>
        </Row.Item>
        {endContent && <Row.Item shrink>{endContent}</Row.Item>}
      </Row>
    </a>
  );
}
